import { render, staticRenderFns } from "./TabSalesDetails.vue?vue&type=template&id=9cb03b9a&scoped=true&"
import script from "./TabSalesDetails.vue?vue&type=script&lang=js&"
export * from "./TabSalesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb03b9a",
  null
  
)

export default component.exports